/**
 * Registry aller Vue-Inseln.
 *
 * Der Schlüssel ist der Wert von `data-vue-component` im Twig-Template, der
 * Wert ein dynamischer Import – so landet eine Insel nur im Bundle der Seiten,
 * die sie wirklich einbinden.
 *
 * Namensschema: `<bereich>/<Komponente>`, Bereich klein, Komponente in
 * PascalCase. **Der Bereich im Schlüssel muss dem Verzeichnis entsprechen** –
 * ein `website/…`, das aus `Core/` lädt, macht die Registry zur Ratestelle.
 * Ein neuer Bereich bekommt ein eigenes Verzeichnis unter `assets/vue/`,
 * keinen Sammelordner (docs/project-structure.md).
 */
export const islands = {
    'core/ConsentBanner': () => import('@app/Core/Components/ConsentBanner.vue'),
    'website/ContactForm': () => import('@app/Website/Components/ContactForm.vue'),
};
